
<script>
  import { resources } from 'apps/imd/stores';
  export let name;

  let href;
  let className = '';
  let restProps = {};

  $: if ($resources) {
    href = $resources.get(name);
  }

  $: {
    ({ name, class: className = '', ...restProps } = $$props);
  }
</script>

{#if href}
  <svg class="resource {className}" {...restProps}>
    <use xlink:href={href} {href}></use>
  </svg>
{/if}

<style>
  .resource {
    --max: 80%;
    --size: auto;
    width: var(--size);
    height: var(--size);
    max-width: var(--max);
    max-height: var(--max);
  }
</style>
